// src/components/EditTermModal/EditTermButton.tsx
import React, { FC, useState } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { ReactComponent as EditFilled } from '../../assets/edit-filled.svg';
import { EditTermModal } from './EditTermModal';
import './EditTermButton.less';

interface EditTermButtonProps {
  wordId: string;
  currentTerm: string;
  currentDefinition: string;
  listId: string;
  onSuccess?: () => void;
  onTermUpdated?: (newTerm: string, newDefinition: string) => void;
  // Gra, która sama przechodzi do kolejnych słów, na czas otwartego okna się zatrzymuje
  onModalVisibleChange?: (visible: boolean) => void;
}

type EditedWord = Pick<EditTermButtonProps, 'wordId' | 'currentTerm' | 'currentDefinition' | 'onTermUpdated'>;

export const EditTermButton: FC<EditTermButtonProps> = ({
  wordId,
  currentTerm,
  currentDefinition,
  listId,
  onSuccess,
  onTermUpdated,
  onModalVisibleChange,
}) => {
  const { t } = useTranslation();
  // Okno trzyma słowo z chwili otwarcia, choćby gra w tym czasie przeszła do następnego. Razem ze słowem
  // zostaje onTermUpdated z tej chwili, więc poprawka trafia w grze do tego samego słowa
  const [editedWord, setEditedWord] = useState<EditedWord | null>(null);
  const isModalVisible = editedWord !== null;

  const handleOpen = () => {
    setEditedWord({
      wordId, currentTerm, currentDefinition, onTermUpdated,
    });
    onModalVisibleChange?.(true);
  };
  const handleClose = () => {
    setEditedWord(null);
    onModalVisibleChange?.(false);
  };

  return (
    <>
      <button
        type="button"
        onClick={handleOpen}
        className="edit-term-button"
      >
        <EditFilled className="anticon-edit" />
        {t('games:buttons.editTerm')}
      </button>

      {/* Portal renderuje modal poza menu opcji, które po kliknięciu się chowa */}
      {editedWord && ReactDOM.createPortal(
        <EditTermModal
          visible={isModalVisible}
          wordId={editedWord.wordId}
          currentTerm={editedWord.currentTerm}
          currentDefinition={editedWord.currentDefinition}
          listId={listId}
          onClose={handleClose}
          onSuccess={onSuccess}
          onTermUpdated={editedWord.onTermUpdated}
        />,
        document.body,
      )}
    </>
  );
};

export default EditTermButton;
